import { memo } from 'react';
import MedicationIcon from '@mui/icons-material/Medication';
import type { SvgIconProps } from '@mui/material/SvgIcon';

type Props = SvgIconProps;

export const Brand = memo((props: Props) => {
  return (
    <MedicationIcon {...props} />
  );
});